import React, { useState } from 'react';
import moment from 'moment';

const CodeFormulier = ({ onSubmit, loading = false, doorsyConfig }) => {
  const [formData, setFormData] = useState({
    vanDatum: moment().format('YYYY-MM-DD'),
    totDatum: moment().add(1, 'days').format('YYYY-MM-DD'), // Eind datum is exclusief
    beschrijving: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when field is updated
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.vanDatum) {
      newErrors.vanDatum = 'Van datum is verplicht';
    }

    if (!formData.totDatum) {
      newErrors.totDatum = 'Tot datum is verplicht';
    }

    if (formData.vanDatum && formData.totDatum) {
      if (moment(formData.totDatum).isSameOrBefore(formData.vanDatum)) {
        newErrors.totDatum = 'Tot datum moet na van datum liggen (eindtijd is exclusief)';
      }
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    // Generate 5-digit code
    const code = Math.floor(10000 + Math.random() * 90000).toString();

    const submitData = {
      pins: [code], // Array van 5-cijfer codes
      startDate: formData.vanDatum, // YYYY-MM-DD format
      endDate: formData.totDatum,   // YYYY-MM-DD format (exclusief)
      metadata: {
        beschrijving: formData.beschrijving,
        aangemaakt: new Date().toISOString(),
        code: code // Voor eigen administratie
      }
    };

    onSubmit(submitData);
  };

  const handleReset = () => {
    setFormData({
      vanDatum: moment().format('YYYY-MM-DD'),
      totDatum: moment().add(1, 'days').format('YYYY-MM-DD'),
      beschrijving: ''
    });
    setErrors({});
  };

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">
          <i className="fas fa-key me-2"></i>
          Nieuwe Toegangscode Aanmaken
        </h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="vanDatum" className="form-label">
                Van Datum <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className={`form-control ${errors.vanDatum ? 'is-invalid' : ''}`}
                id="vanDatum"
                name="vanDatum"
                value={formData.vanDatum}
                onChange={handleChange}
                min={moment().format('YYYY-MM-DD')}
              />
              {errors.vanDatum && (
                <div className="invalid-feedback">
                  {errors.vanDatum}
                </div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label htmlFor="totDatum" className="form-label">
                Tot Datum <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className={`form-control ${errors.totDatum ? 'is-invalid' : ''}`}
                id="totDatum"
                name="totDatum"
                value={formData.totDatum}
                onChange={handleChange}
                min={formData.vanDatum || moment().format('YYYY-MM-DD')}
              />
              {errors.totDatum && (
                <div className="invalid-feedback">
                  {errors.totDatum}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <label htmlFor="beschrijving" className="form-label">
                Beschrijving (optioneel)
              </label>
              <textarea
                className="form-control"
                id="beschrijving"
                name="beschrijving"
                rows="3"
                value={formData.beschrijving}
                onChange={handleChange}
                placeholder="Voeg een beschrijving toe voor deze toegangscode..."
              />
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <div>
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Aanmaken...
                  </>
                ) : (
                  <>
                    <i className="fas fa-plus me-2"></i>
                    Code Aanmaken
                  </>
                )}
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleReset}
                disabled={loading}
              >
                <i className="fas fa-undo me-2"></i>
                Reset
              </button>
            </div>

            <div className="text-muted">
              <small>
                <i className="fas fa-info-circle me-1"></i>
                Er wordt automatisch een 5-cijferige code gegenereerd en naar RecraPlan API verzonden
              </small>
            </div>
          </div>

          <div className="alert alert-info mt-3">
            <i className="fas fa-exclamation-circle me-2"></i>
            <strong>Let op:</strong> De einddatum is <strong>exclusief</strong>. Voor toegang op 1 en 2 oktober: startdatum = 2025-10-01, einddatum = 2025-10-03.
          </div>
        </form>
      </div>
    </div>
  );
};

export default CodeFormulier;